export const TSV = 'text/tab-separated-values';
export const CSV = 'text/csv';
export const TXT = 'text/plain';
export const XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const JSON = 'application/json';
